import { deleteCookie } from "utils/cookie-utiils";

export const removePromoCode = () => {
  deleteCookie(null, "promocode");
};
